import { VariableType } from "@/utils/types/variables";

export enum VARIABLE_TYPE_ENUM {
  STRING = "STRING",
  ARRAY_STRING = "ARRAY_STRING",
  BOOLEAN = "BOOLEAN",
  ARRAY_BOOLEAN = "ARRAY_BOOLEAN",
  NUMBER = "NUMBER",
  ARRAY_NUMBER = "ARRAY_NUMBER",
  ITEM_ID = "ITEM_ID",
  ARRAY_ITEM_ID = "ARRAY_ITEM_ID",
  CATEGORY_ID = "CATEGORY_ID",
  ARRAY_CATEGORY_ID = "ARRAY_CATEGORY_ID",
  USER = "USER",
  TAG = "TAG",
  SESSION_ID = "SESSION_ID",
  EMOTION = "EMOTION",
  DATE = "DATE",
  OBJECT_STRING = "OBJECT_STRING",
  OBJECT_BOOLEAN = "OBJECT_BOOLEAN",
  OBJECT_NUMBER = "OBJECT_NUMBER",
  ARRAY_OBJECT_STRING = "ARRAY_OBJECT_STRING",
  ARRAY_OBJECT_BOOLEAN = "ARRAY_OBJECT_BOOLEAN",
  ARRAY_OBJECT_NUMBER = "ARRAY_OBJECT_NUMBER",
}

export const VARIABLE_NEED_PROPERTY_OF_DATASET: Dic<string> = {
  [VARIABLE_TYPE_ENUM.ITEM_ID]: "item",
  [VARIABLE_TYPE_ENUM.ARRAY_ITEM_ID]: "item",
  [VARIABLE_TYPE_ENUM.USER]: "user",
  [VARIABLE_TYPE_ENUM.SESSION_ID]: "session",
};

export const VARIABLE_CAN_BE_PROPERTY_FOR_ARRAY_ITEM_ID = [
  VARIABLE_TYPE_ENUM.STRING,
  VARIABLE_TYPE_ENUM.ARRAY_STRING,
];

export const CURRENT_TIMESTAMP = "_current_timestamp";
export const INTERN_VARIABLES = [
  {
    id: "-1",
    name: CURRENT_TIMESTAMP,
    type: VARIABLE_TYPE_ENUM.DATE,
    config: {},
  } as VariableType,
];

export const getEmojiForInternVariable = (variable: string) => {
  if (variable === CURRENT_TIMESTAMP) return "⏱️";
  return "";
};
